module.exports = __webpack_public_path__ + "media/images/icons/plus-a355f2bc6b131ffbea4b46147f36e506.svg";